import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import moment from 'moment'
import { extendObservable, action } from 'mobx'
import enhanceWithClickOutside from 'react-click-outside'
import PropTypes from 'prop-types'
import DateRangeIcon from '@material-ui/icons/DateRange'
import PeopleIcon from '@material-ui/icons/People'

import MonthYearCalendar from '@components/MonthPicker/MonthYearCalendar'
import Tooltip from '@components/Tooltip'

import TeamRevenueMobile from './TeamRevenueMobile'
import SubTeamSelector from './SubTeamSelector'
import WidgetBox from '../WidgetBox'

import { formatNoDecimalBigInt, formatNoDecimal, formatDecimal } from '@atheneum/api/dist/lib'

class TeamRevenue extends Component {
  static propTypes = {
    dashboardStore: PropTypes.object,
    teamRevenueData: PropTypes.object,
    activeTeamId: PropTypes.number,
    setDate: PropTypes.func,
    date: PropTypes.string,
    setSubTeamActive: PropTypes.func,
    setSubTeamActiveTab: PropTypes.func,
    activeSubTeamNumber: PropTypes.number,
    subTeamActive: PropTypes.bool
  }

  constructor(props) {
    super(props)

    extendObservable(this, {
      isCalendarShown: false
    })

    this.datePicker = null
  }

  handleCalendarDisplay = () => {
    this.isCalendarShown = true
  }

  handleClickOutside = () => {
    this.closeCalendar()
  }

  closeCalendar = () => {
    this.isCalendarShown = false
  }

  handleDateChange = action(date => {
    const { getTeamRevenueWidgetData } = this.props.dashboardStore
    this.props.setDate(date)
    const newDate = moment(date).format('MM-YYYY')
    !this.props.activeTeamId
      ? getTeamRevenueWidgetData(newDate)
      : getTeamRevenueWidgetData(newDate, this.props.activeTeamId)
    this.props.setSubTeamActive(false)
  })

  onMonthPress = monthAndYear => {
    this.isCalendarShown = false
    this.handleDateChange(monthAndYear)
  }

  render() {
    const {
      getFilteredFilteredSubTeams,
      getTotalTeamMembersValues,
      getSortedTeamMembers,
      getFormattedTeamMembers
    } = this.props.dashboardStore

    if (!this.props.teamRevenueData) return null

    const mainTeam = getSortedTeamMembers(getFormattedTeamMembers())
    const subTeams = getFilteredFilteredSubTeams()
      .map(getFormattedTeamMembers)
      .map(getSortedTeamMembers)
    const team = this.props.subTeamActive
      ? subTeams[this.props.activeSubTeamNumber]
      : mainTeam

    const teamTotal = getTotalTeamMembersValues()
    const subTeamTotal = getFilteredFilteredSubTeams().map(
      getTotalTeamMembersValues
    )[this.props.activeSubTeamNumber]
    const total = this.props.subTeamActive ? subTeamTotal : teamTotal

    const tab = teamMembers => (
      <div className="team-list">
        {teamMembers.map((teamMember, index) => (
          <div className="teamRevenue-table-row" key={index}>
            <div className="teamRevenue-table-cell">
              <Tooltip tooltip={teamMember.fullName}>
                <span className="no-text-overflow">{teamMember.fullName}</span>
              </Tooltip>
            </div>
            <div className="teamRevenue-table-cell">
              <Tooltip
                tooltip={
                  teamMember.is_senior
                    ? 'Senior ' + teamMember.position
                    : teamMember.position
                }>
                <span className="no-text-overflow">
                  {teamMember.is_senior ? 'Senior ' : ''}
                  {teamMember.position}
                </span>
              </Tooltip>
            </div>
            <div className="teamRevenue-table-cell">
              {teamMember.employeeDeliveries}
            </div>
            <div className="teamRevenue-table-cell">
              {' '}
              {teamMember.interviewCount}
            </div>
            <div className="teamRevenue-table-cell">
              {formatNoDecimalBigInt(teamMember.revenue)}
            </div>
            <div className="teamRevenue-table-cell">
              {formatNoDecimalBigInt(teamMember.cost)}
            </div>
            <div className="teamRevenue-table-cell">
              {formatNoDecimal(teamMember.grossMargin)}
            </div>
            <div className="teamRevenue-table-cell">
              {formatNoDecimal(teamMember.targetMargin)}
            </div>
            <div className="teamRevenue-table-cell">
              {formatDecimal(teamMember.achievement)}
            </div>
          </div>
        ))}
      </div>
    )

    const date = this.props.date

    const accountManagerToolTipText = [
      { key: 'accountManager', label: 'Account Manager' },
      { key: 'seniorAccountManager', label: 'Senior Account Manager' },
      { key: 'principal', label: 'Principal' },
      { key: 'seniorPrincipal', label: 'Senior Principal' }
    ]
      .map(
        ({ key, label }) =>
          this.props.teamRevenueData[key] && (
            <div>
              <span
                style={{ opacity: 0.8, width: 150, display: 'inline-block' }}>
                {label}:{' '}
              </span>
              <strong>{this.props.teamRevenueData[key]}</strong>
            </div>
          )
      )
      .filter(Boolean)

    return (
      <WidgetBox
        label="Team Revenue"
        action={
          <div className="teamRevenue-action-section">
            {(this.props.teamRevenueData.accountManager ||
              this.props.teamRevenueData.principal) && (
              <div className="mobile-account-manager-icon">
                <Tooltip tooltip={accountManagerToolTipText} method={'click'}>
                  <PeopleIcon className="mobile-menu-icon" />
                </Tooltip>
              </div>
            )}
            <Tooltip tooltip={accountManagerToolTipText}>
              <div>
                <div className="account-manager-section">
                  {this.props.teamRevenueData.accountManager && (
                    <div>
                      {this.props.teamRevenueData.seniorAccountManager && (
                        <div className="account-manager">
                          <div>
                            <strong>Senior Account Manager:</strong>{' '}
                            {this.props.teamRevenueData.seniorAccountManager}
                          </div>
                        </div>
                      )}
                      <div className="account-manager">
                        <div>
                          <strong>Account Manager:</strong>{' '}
                          {this.props.teamRevenueData.accountManager}
                        </div>
                      </div>
                    </div>
                  )}
                  {this.props.teamRevenueData.accountManager &&
                    this.props.teamRevenueData.principal && (
                      <div className={'divider'} />
                    )}
                  {this.props.teamRevenueData.principal && (
                    <div>
                      {this.props.teamRevenueData.seniorPrincipal && (
                        <div className="principal">
                          <div>
                            <strong>Senior Principal:</strong>{' '}
                            {this.props.teamRevenueData.seniorPrincipal}
                          </div>
                        </div>
                      )}
                      <div className="principal">
                        <div>
                          <strong>Principal:</strong>{' '}
                          {this.props.teamRevenueData.principal}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </Tooltip>
            <div className="widget-box__top-bar__action--opacity">
              <button
                readOnly
                className="teamRevenue-widget__datepicker"
                onClick={this.handleCalendarDisplay}>
                <DateRangeIcon />
                <div className="datepicker-text">{date}</div>
              </button>
            </div>
          </div>
        }>
        <div className="mobile-teamRevenue">
          <SubTeamSelector
            subTeams={subTeams}
            subTeamActive={this.props.subTeamActive}
            activeSubTeamNumber={this.props.activeSubTeamNumber}
            teamName={this.props.teamRevenueData.teamName}
            setSubTeamActive={this.props.setSubTeamActive}
            setSubTeamActiveTab={this.props.setSubTeamActiveTab}
            slidesToShow={2}
          />
          <TeamRevenueMobile
            totals={total}
            teamMembers={team}
            activeSubTeamNumber={this.props.activeSubTeamNumber}
            subTeamActive={this.props.subTeamActive}
          />
        </div>
        <div className="desktop-teamRevenue">
          <div className="teamRevenue-widget">
            <SubTeamSelector
              subTeams={subTeams}
              subTeamActive={this.props.subTeamActive}
              activeSubTeamNumber={this.props.activeSubTeamNumber}
              teamName={this.props.teamRevenueData.teamName}
              setSubTeamActive={this.props.setSubTeamActive}
              setSubTeamActiveTab={this.props.setSubTeamActiveTab}
              slidesToShow={6}
            />

            <div className="teamRevenue-table-row total-row top-total-row">
              <div className="teamRevenue-table-cell">
                <Tooltip tooltip={'Name'}>
                  <span className="no-text-overflow">Name</span>
                </Tooltip>
              </div>
              <div className="teamRevenue-table-cell">
                <Tooltip tooltip={'Position'}>
                  <span className="no-text-overflow">Position</span>
                </Tooltip>
              </div>
              <div className="teamRevenue-table-cell">
                <Tooltip tooltip={'Deliveries'}>
                  <span className="no-text-overflow">Dv</span>
                </Tooltip>
              </div>
              <div className="teamRevenue-table-cell">
                <Tooltip tooltip={'Interviews'}>
                  <span className="no-text-overflow">Iv</span>
                </Tooltip>
              </div>
              <div className="teamRevenue-table-cell">
                <Tooltip tooltip={'Revenue €'}>
                  <span className="no-text-overflow">Revenue €</span>
                </Tooltip>
              </div>
              <div className="teamRevenue-table-cell">
                <Tooltip tooltip={'Costs €'}>
                  <span className="no-text-overflow">Costs €</span>
                </Tooltip>
              </div>
              <div className="teamRevenue-table-cell">
                <Tooltip tooltip={'Gross Margin €'}>
                  <span className="no-text-overflow">Gross Margin €</span>
                </Tooltip>
              </div>
              <div className="teamRevenue-table-cell">
                <Tooltip tooltip={'Target €'}>
                  <span className="no-text-overflow">Target €</span>
                </Tooltip>
              </div>
              <div className="teamRevenue-table-cell">
                <Tooltip tooltip={'Achievement %'}>
                  <span className="no-text-overflow">Achievement %</span>
                </Tooltip>
              </div>
            </div>
            {tab(
              this.props.subTeamActive
                ? subTeams[this.props.activeSubTeamNumber]
                : mainTeam
            )}
            <div className="teamRevenue-table-row total-row bottom-total-row">
              <div className="teamRevenue-table-cell" />
              <div className="teamRevenue-table-cell">Total</div>
              <div className="teamRevenue-table-cell">
                {total.employeeDeliveries}
              </div>
              <div className="teamRevenue-table-cell">
                {total.interviewCount}
              </div>
              <div className="teamRevenue-table-cell">
                {formatNoDecimalBigInt(total.revenue)}
              </div>
              <div className="teamRevenue-table-cell">
                {formatNoDecimalBigInt(total.cost)}
              </div>
              <div className="teamRevenue-table-cell">
                {formatNoDecimal(total.grossMargin)}
              </div>
              <div className="teamRevenue-table-cell">
                {formatNoDecimal(total.targetMargin)}
              </div>
              <div className="teamRevenue-table-cell">
                {formatDecimal(total.achievement)}
              </div>
            </div>
          </div>
        </div>
        {this.isCalendarShown && (
          <MonthYearCalendar
            closeCalendar={this.closeCalendar}
            activeMonthAndYear={date}
            onMonthPress={this.onMonthPress}
          />
        )}
      </WidgetBox>
    )
  }
}

export default inject(
  'userStore',
  'dashboardStore'
)(enhanceWithClickOutside(observer(TeamRevenue)))
